import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const AdminDocumentData = lazy(() => import("@/pages/admin/AdminDocumentData"));

export const Route = createFileRoute("/admin/dokumentdata")({
  head: () => ({ meta: [{ title: "Dokumentdata | Admin" }, { name: "robots", content: "noindex" }] }),
  component: () => <AdminDocumentData />,
});
